import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import user from './user'
import { CommunicatorInfoStore, LatestInfoStore, SubscriptionInfoStore, UniversalSearchStore } from '@cd/sdds-common-components-react'
import { createSelectorHook, useDispatch } from 'react-redux'
import batchSearchStore from "./batchSearch";
import loadCscEquipmentData from './serviceConfiguration';
import communicationHistory from './communicationHistory'
import historicalData from './historicalDataVariables'
import rtcUnitLog from './rtcUnitLog'
import MPLog from './MPLog';
import csdState from "./CSDsStore";
import vehicleRtcHistory from './vehicleRtcHistory'

const reducer = combineReducers({
  user,
  subscriptionInfo: SubscriptionInfoStore,
  latestInfo: LatestInfoStore,
  communicatorInfo: CommunicatorInfoStore,
  universalSearch: UniversalSearchStore,
  batchSearchStore: batchSearchStore,
  cscEquipmentStore: loadCscEquipmentData,
  communicationHistoryStore: communicationHistory,
  historicalDataStore: historicalData,
  rtcUnitLog,
  mpLogStore:MPLog,
  csdState:csdState,
  vehicleRtcHistory: vehicleRtcHistory
});

const store = configureStore({
  reducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector = createSelectorHook<RootState>();
export default store;